export const turquoise = 'rgb(14, 171, 190)'
export const blue = '#5563CD'
export const lightcyan = '#eefdfd'
export const moneyGreen = '#2cf562'
